<template>
    <vacancies-filter :filter_title="filter_title" :filters="filters" :filter_visibility="filter_visibility"></vacancies-filter>
    <div class="o-vacancies-listing" id="js-vacancies-listing">
        <div class="grid-container">
            <div class="grid-x grid-margin-x">
                <div class="small-12 cell">
                    <div class="o-vacancies-listing__wrapper" :class="listingsClass">
                        <start-message v-if="isFiltering == false && !show_listings_initially"></start-message>
                        <vacancies-list v-if="( show_listings_initially || isFiltering == true ) && filteredJobs?.length > 0"></vacancies-list>
                        <no-vacancies v-if="( show_listings_initially || isFiltering == true ) && filteredJobs?.length == 0"></no-vacancies>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VacanciesFilter from './filter/index';
    import VacanciesList from './listing/index';
    import StartMessage from './listing/start-message';
    import NoVacancies from './listing/no-vacancies';

    import vacanciesMixin from "../../mixins/vacancies";

    export default {
        name: 'Vacancies',
        props: ['filter_title', 'filters', 'all_jobs', 'preset_filters', 'filter_visibility', 'show_listings_initially'],
        components: {
            VacanciesFilter,
            VacanciesList,
            StartMessage,
            NoVacancies
        },
        mixins: [vacanciesMixin],
        computed: {
            listingsClass() {
                let vm = this;

                if( vm.isFiltering == false ||  vm.filteredJobs?.length == 0 ) {
                    return 'o-vacancies-listing__wrapper--message';
                }

                return 'o-vacancies-listing__wrapper--results';
            }
        },
        created(){
            let vm = this,
                isFiltering = false,
                filteredJobs = null;

            filteredJobs = vm.all_jobs;

            Object.keys(vm.preset_filters).forEach((filter, index) => {
                if( vm.activeFilters[filter] !== undefined ) {
                    vm.activeFilters[filter].value = vm.preset_filters[filter].value;

                    if( vm.activeFilters[filter].type == 'single' && vm.activeFilters[filter].value !== null ){
                        filteredJobs = vm.filterBySingle( filteredJobs, filter );
                        isFiltering = true;
                    }
                    if( vm.activeFilters[filter].type == 'multiple' && vm.activeFilters[filter].value.length !== 0 ){
                        filteredJobs = vm.filterByMultiple( filteredJobs, filter );
                        isFiltering = true;
                    }
                    if( vm.activeFilters.location.value.lat != null && vm.activeFilters.location_radius.value !== null ){
                        filteredJobs = vm.filterByLocation( filteredJobs );
                        isFiltering = true;
                    }
                    if( vm.activeFilters.specific_region.value != null ){
                        filteredJobs = vm.filterBySpecificRegion( filteredJobs );
                        isFiltering = true;
                    }

                }
            });

            vm.$store.dispatch( 'updateJobs', vm.all_jobs );
            vm.$store.dispatch( 'updateIsFiltering', isFiltering );
            vm.$store.dispatch( 'updateFilteredJobs', filteredJobs );

        },
        data() {
            return {
            }
        }
    }
</script>